export default async function genCaptchaKeyAsync(captchaKey) {
  try {
    const token = await window.grecaptcha.execute(captchaKey, { action: 'submit' });
    return token;
  } catch (e) {
    return 'error_string';
  }
}
